import { createApp } from 'vue'
import App from './App.vue'
import { 
  initGoogleAnalytics, 
  setupInteractionTracking, 
  initHeatmapTracking, 
  setupErrorTracking 
} from './utils/analytics'
import { 
  setupLazyLoading, 
  preloadCriticalResources, 
  trackPerformance 
} from './utils/performance'

// 创建应用
const app = createApp(App)

// 挂载应用
app.mount('#app')

// 初始化分析和性能监控
document.addEventListener('DOMContentLoaded', () => {
  // 分析工具初始化
  initGoogleAnalytics()
  setupInteractionTracking()
  initHeatmapTracking()
  setupErrorTracking()
  
  // 性能优化
  setupLazyLoading()
  preloadCriticalResources()
  trackPerformance()
})
